import { SelectLocationViewCmpDesktop } from '@porterin/component-library/src/location-accuracy/components/SelectLocationViewCmpDesktop';
import React from 'react';
import { useSelectLocationController } from '@porterin/component-library/src/location-accuracy/hooks/useSelectLocationController';

export interface SelectLocationProps {
  close_modal: () => void;
}

export const SelectLocationControllerCmpDesktop: React.FC<
  SelectLocationProps
> = ({ close_modal }) => {
  const { predictions, errors, updateField, handlePredictionClick } =
    useSelectLocationController();

  return (
    <SelectLocationViewCmpDesktop
      close_modal={close_modal}
      predictions={predictions}
      on_prediction_click={handlePredictionClick}
      error={errors?.root?.message}
      register={updateField}
    />
  );
};
